const STRING_REQUIRED = 'stringRequired';
const FILE_REQUIRED = 'fileRequired';
const CANNOT_BE_EMPTY = 'cannotBeEmpty';

export { STRING_REQUIRED, FILE_REQUIRED, CANNOT_BE_EMPTY };
